
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-prompt-engineering-guide-for-beginners",
      function () {
        return require("private-next-pages/ai-prompt-engineering-guide-for-beginners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-prompt-engineering-guide-for-beginners"])
      });
    }
  